import { CommonModule } from "@angular/common";
import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTable, MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router, RouterLink } from "@angular/router";
import { NgxCurrencyDirective } from "ngx-currency";
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from "ngx-mask";
import { Ordem } from "src/app/core/apis/orchestrador/model/ordem";
import { Globals } from "src/app/core/helpers/globals";
import { TitularOrdem } from "src/app/core/apis/orchestrador/model/titularOrdem";
import { OrdemInclusao, OrdemSolicitacao } from "src/app/core/apis/orchestrador/model/solicitacao/ordem-solicitacao";
import { Titular } from "src/app/core/apis/orchestrador/model/solicitacao/titular";
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';
import { NoSpecialCharsDirective } from 'src/app/shared/directive/no-special-chars.directive';
import { StringUtil } from "src/app/shared/util/string-util";
import { CustomValidators } from "src/app/shared/validators/custom-validators";
import { CpfCnpjService } from "../../../../../../core/service/cpf-cnpj.service";
import { SolicitacaoService } from './../../../../../../core/apis/orchestrador/api/solicitacao.service';

@Component({
    selector: "app-atualizar-acao-form",
    templateUrl: "./atualizar-acao-form.component.html",
    styleUrls: ["./atualizar-acao-form.component.css"],
    standalone: true,
    providers: [provideNgxMask()],
    imports: [
      CommonModule,
      ReactiveFormsModule,
      FormsModule,
      MatFormFieldModule,
      MatInputModule,
      MatIconModule,
      NgxMaskDirective,
      MatButtonModule,
      MatTableModule,
      MatMenuModule,
      MatProgressSpinnerModule,
      NgxCurrencyDirective,
      RouterLink,
      NgxMaskPipe,
      MatTooltipModule,
      NoSpecialCharsDirective
    ],
})
export class AtualizarAcaoFormComponent implements OnInit {

  usuario: any;
  tpUsuario: any;

  @Input() tokenIam: string;
  @Input() nroProcesso: string;
  @Input() ordem: Ordem;

  ordemInclusao: OrdemInclusao;

  form: UntypedFormGroup;

  @ViewChild(MatTable) table: MatTable<TitularOrdem>;
  displayedColumns: string[] = ["nome", "documento", "action"];
  editedTitular: Titular = null;

  titulares: Titular[];
  idTitulares: number = 1;

  identificadorDevedor: number;
  sequenciaDevedor: number;

  constructor(
    private router: Router,
    private globals: Globals,
    public snackBar: MatSnackBar,
    private cpfCnpjService: CpfCnpjService,
    private solicitacaoService: SolicitacaoService,
    public dialog: MatDialog,
    fb: UntypedFormBuilder
  ) {
    this.form = fb.group({
      titular: fb.group({
        nome: ["", [Validators.required, CustomValidators.validatorOnlyNumber]],
        documento: ["", Validators.required],
      }),
      vlrAcao: ["", [Validators.required, CustomValidators.validatorCurrencyZero]],
      nomeEdicao: ["", [Validators.required, CustomValidators.validatorOnlyNumber]],
      documentoEdicao: ["", Validators.required],
    });
    this.usuario = JSON.parse(sessionStorage.getItem("usuario"));
    this.tpUsuario = sessionStorage.getItem('cargo');
  }

  ngOnInit() {
    this.titulares = this.mapToTitulares(this.ordem.titulares);
    this.form.patchValue({ vlrAcao: this.ordem?.acao.vlrAcao });
    this.ordemInclusao = this.createOrdemInclusao()
  }

  public addTitular() {
    let titular = this.buildTitular(this.nome.value, this.documento.value);

    if (this.isDocumentoValido(titular.documento)) {
      const docExistente = this.titulares.filter(element => element.documento == titular.documento);
      if (docExistente.length > 0) {
        this.globals.showSnackBar("Titular já cadastrado!");
        return;
      }
      this.titulares.push(titular);
      this.idTitulares++;

      this.nome.reset();
      this.documento.reset();

      this.table.renderRows();

      if (this.titulares.length === 1) {
        this.showMessageDialog();
      }
    } else {
      this.globals.showSnackBar("Número do documento inválido!");
    }

  }

  private showMessageDialog() {
    const data = {
      messages: ['Se houver mais titulares, adicionar nesse momento!'],
      confirmText: 'Entendi',
      showCancel: false
    };

    this.dialog.open(DialogComponent, {
      width: '470px',
      data: data
    });
  }

  private buildTitular(nome: string, documento: string): Titular {
    return {
      nome: nome.trim(),
      documento: StringUtil.removeNonNumber(documento)
    };
  }

  public startEdicao(titular: Titular) {
    this.nomeEdicao.setValue(titular.nome)
    this.documentoEdicao.setValue(titular.documento)
    this.editedTitular = titular;
  }

  public atualizarTitular(titular: Titular) {
    if (!this.isDocumentoValido(this.documentoEdicao.value)) {
        this.globals.showSnackBar("Número do documento inválido!");
        this.editedTitular = null;
        this.table.renderRows();
        return;
    }

    const index = this.titulares.indexOf(titular);
    if (index !== -1) {
        this.titulares[index].nome = this.nomeEdicao.value.trim();
        this.titulares[index].documento = this.documentoEdicao.value.replace(/\D/g, "");
        this.globals.showSnackBar("Informações do titular atualizadas!", ["snackbar-success"]);
    }

    this.editedTitular = null;
    this.table.renderRows();
}

  public removerTitular(titular) {
    let index = this.titulares.indexOf(titular);
    this.titulares.splice(index, 1);
    this.table.renderRows();
  }

  public handleAtualizarAcao() {
    let ordemUpdate: OrdemInclusao = {...this.ordemInclusao,
      titulares: OrdemSolicitacao.processarTitulares(this.titulares, "ACAO"),
      dadosOrdem: {...this.ordemInclusao.dadosOrdem,
        valorAnotacao: this.vlrAcao.value
      }
    }

    this.globals.addToLoading("cadastrar-ordem");
    this.solicitacaoService.saveSolicitacao(ordemUpdate, this.tokenIam)
    .subscribe({
      next: response => {
        this.globals.subtractFromLoading();
        this.globals.showSnackBar("Atualização enviada com sucesso!", ["snackbar-success"]);
        this.router.navigate(["/ordem"]);
      },
      error: (error) => {
        this.globals.subtractFromLoading();
        if (error.error.Erros)
          error.error.Erros.forEach(erro => this.globals.showSnackBar(erro.message));
        else
          this.globals.showSnackBar("Inclusão de ações indisponível, por favor, tente novamente mais tarde.");
      }
    });
  }

  public disableAddDevedor(): boolean {
    return !this.nome.valid || !this.documento.valid;
  }

  public disableAtualizarTitular(): boolean {
    return !this.nomeEdicao.valid || !this.documentoEdicao.valid;
  }

  public disableAtualizarAcao(): boolean {
    return !this.vlrAcao.valid || (!this.hasValorChanged() && !this.hasTitularesChanged());
  }

  private hasValorChanged(): boolean {
    return this.vlrAcao.value !== this.ordemInclusao.dadosOrdem.valorAnotacao;
  }

  private hasTitularesChanged(): boolean {
    if (this.titulares.length !== this.ordemInclusao.titulares.length) {
      return true;
    }

    return this.titulares.some(titular => {
      const ordemTitular = this.ordemInclusao.titulares.find(o => o.documento === titular.documento);
      return !ordemTitular || titular.nome !== ordemTitular.nome;
    });
  }

  public isPessoaFisica(nroDocumento: string) {
    return nroDocumento.length == 11;
  }

  private mapToTitulares(titularesOficio: any[]): Titular[] {
    return titularesOficio.map((titular: any) => ({
      nome: titular.nome,
      documento: titular.nroDocumento,
    }));
  }

  private isDocumentoValido(cpfCnpj: string) {
    return this.cpfCnpjService.validateCpfCnpj(cpfCnpj);
  }

  private createOrdemInclusao(): OrdemInclusao {
    return {
      numeroProcesso: this.nroProcesso,
      titulares: this.mapToTitulares(this.ordem.titulares),
      horasSla: this.ordem.nroSla > 0 ? this.ordem.nroSla : 120,
      magistrado: {
        id: this.ordem.varaMagistrado.magistrado.id,
        nome: this.ordem.varaMagistrado.magistrado.nome,
        documento: this.ordem.varaMagistrado.magistrado.cpf
      },
      cadastrador: {
        nome: this.hasDadosCadastrador() ? this.ordem.nomeServidor : this.usuario?.fullName,
        documento: this.hasDadosCadastrador() ? this.ordem.nroDocumentoServidor : this.usuario.document?.documentId,
      },
      foro: {
        id: this.ordem.vara.foro.id,
        nome: this.ordem.vara.foro.nome
      },
      praca: {
        sigla: this.ordem.vara.foro.praca.sigla,
        nome: this.ordem.vara.foro.praca.nome,
        uf: this.ordem.vara.foro.praca.uf
      },
      vara: {
        id: this.ordem.vara.id,
        nome: this.ordem.vara.nome,
        numero: Number(this.ordem.vara.numero)
      },
      subEsfera: {
        id: this.ordem.vara.foro.subEsfera.id,
        nome: this.ordem.vara.foro.subEsfera.nome
      },
      esfera: {
        id: this.ordem.vara.foro.subEsfera.esfera.id,
        nome: this.ordem.vara.foro.subEsfera.esfera.nome
      },
      tipoOrdem: this.ordem.tpOrdem,
      dadosOrdem: {
        valorAnotacao: this.ordem.acao.vlrAcao,
        nomeAutor: this.ordem.autor,
        nomeReu: this.ordem.reu,
        nomeCredor: this.ordem.autor,
        cartaComunicado: this.ordem.cartaComunicado
      }
    };
  }

  private hasDadosCadastrador(): boolean {
    return this.ordem.nomeServidor != null && this.ordem.nroDocumentoServidor != null;
  }

  get nome() {
    return this.form.get("titular.nome");
  }

  get documento() {
    return this.form.get("titular.documento");
  }

  get nomeEdicao() {
    return this.form.get("nomeEdicao");
  }

  get documentoEdicao() {
    return this.form.get("documentoEdicao");
  }

  get vlrAcao() {
    return this.form.get("vlrAcao");
  }

}
